import axios from 'axios';

const getBaseUrl = () => process.env.REACT_APP_BACKEND_URL
  || (typeof window !== 'undefined' ? `${window.location.protocol}//${window.location.host}` : '');

export const publicApi = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json'
  }
});

export const getApiUrl = getBaseUrl;
